var map = {
	"./10_of_clubs.png": 6630,
	"./10_of_diamonds.png": 7841,
	"./10_of_hearts.png": 7580,
	"./10_of_spades.png": 7936,
	"./2_of_clubs.png": 4344,
	"./2_of_diamonds.png": 6759,
	"./2_of_hearts.png": 8390,
	"./2_of_spades.png": 2670,
	"./3_of_clubs.png": 2583,
	"./3_of_diamonds.png": 8586,
	"./3_of_hearts.png": 4327,
	"./3_of_spades.png": 192,
	"./4_of_clubs.png": 4679,
	"./4_of_diamonds.png": 3792,
	"./4_of_hearts.png": 9347,
	"./4_of_spades.png": 9925,
	"./5_of_clubs.png": 6697,
	"./5_of_diamonds.png": 465,
	"./5_of_hearts.png": 6067,
	"./5_of_spades.png": 305,
	"./6_of_clubs.png": 6615,
	"./6_of_diamonds.png": 865,
	"./6_of_hearts.png": 8266,
	"./6_of_spades.png": 4198,
	"./7_of_clubs.png": 9106,
	"./7_of_diamonds.png": 6082,
	"./7_of_hearts.png": 7950,
	"./7_of_spades.png": 4443,
	"./8_of_clubs.png": 3744,
	"./8_of_diamonds.png": 3300,
	"./8_of_hearts.png": 6601,
	"./8_of_spades.png": 8221,
	"./9_of_clubs.png": 6877,
	"./9_of_diamonds.png": 6306,
	"./9_of_hearts.png": 1509,
	"./9_of_spades.png": 6142,
	"./ace_of_clubs.png": 93,
	"./ace_of_diamonds.png": 6017,
	"./ace_of_hearts.png": 3665,
	"./ace_of_spades.png": 4915,
	"./jack_of_clubs.png": 2919,
	"./jack_of_diamonds.png": 9766,
	"./jack_of_hearts.png": 8380,
	"./jack_of_spades.png": 2415,
	"./king_of_clubs.png": 3634,
	"./king_of_diamonds.png": 9933,
	"./king_of_hearts.png": 3131,
	"./king_of_spades.png": 9225,
	"./logo.png": 6949,
	"./queen_of_clubs.png": 2437,
	"./queen_of_diamonds.png": 4832,
	"./queen_of_hearts.png": 8341,
	"./queen_of_spades.png": 629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2594;